import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const VehicleInsuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section vehicle-insurance-fin">
                <h2 className="other-pages-title">Vehicle Insurance</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/vehicle-insurance-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Vehicle Insurance</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Vehicle Insurance?</h2>

                <p className="info-loan-description-smco">
                    Vehicle insurance, also known as auto insurance or car insurance, is a contract between a vehicle owner and an insurance company that provides financial protection against physical damage to the vehicle and liability for injuries or property damage caused by the vehicle. It covers risks like accidents, theft, vandalism, and natural disasters.
                    <br /><br />
                    There are two main types: Third-Party Liability Insurance (mandatory by law) and Comprehensive Insurance (optional but recommended). Third-party covers damage or injury to others, while comprehensive also covers damage to your own vehicle. Additional covers like zero depreciation, roadside assistance, and engine protection can be added.
                    <br /><br />
                    Premiums are calculated based on vehicle type, age, model, location, driving record, and coverage type. Safe drivers and vehicles with security features get lower rates. Vehicle insurance is mandatory for all registered vehicles in India and helps avoid hefty repair costs or legal liabilities.
                    <br /><br />
                    Regular maintenance, safe driving, and choosing the right policy can help keep premiums affordable. It's wise to compare policies and opt for cashless repairs at network garages for hassle-free claims.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Third-party liability:</strong> Covers damage/injury to others (mandatory).</li>
                        <li><strong>Own damage coverage:</strong> Protects your vehicle from damage/theft.</li>
                        <li><strong>Cashless repairs:</strong> Direct settlement at network garages.</li>
                        <li><strong>No-claim bonus:</strong> Discount for claim-free years.</li>
                        <li><strong>Add-on covers:</strong> Zero depreciation, roadside assistance, etc.</li>
                        <li><strong>Legal compliance:</strong> Required for vehicle registration and renewal.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Vehicle Insurance</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Third-Party Insurance:</strong> Basic coverage for liability to others.</li>
                        <li><strong>Comprehensive Insurance:</strong> Full coverage including own damage.</li>
                        <li><strong>Two-Wheeler Insurance:</strong> Specialized for bikes and scooters.</li>
                        <li><strong>Commercial Vehicle Insurance:</strong> For taxis, trucks, and business vehicles.</li>
                        <li><strong>Pay-as-you-drive:</strong> Premium based on actual usage.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Financial protection:</strong> Covers repair costs and legal liabilities.</li>
                        <li><strong>Peace of mind:</strong> Safe driving without worry of accidents.</li>
                        <li><strong>Legal requirement:</strong> Mandatory for all vehicles on Indian roads.</li>
                        <li><strong>Tax benefits:</strong> Premiums may be tax-deductible.</li>
                        <li><strong>Resale value:</strong> Insured vehicles have higher market value.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default VehicleInsuranceInfo;
